module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/enquiry_sent-339ceb44d566d1e53b5d62f78d0c2b7e.png";